import { useEffect } from 'react';
import { SiteConfigManager } from '@atlas/core';
import { setNextShowForPopupSignUpDelay } from 'helpers/setNextShowForPopupSignUpDelay';

export const useSetNextShowPopupSignUpDelay = () => {
  useEffect(() => {
    const enableSignUpDelay = SiteConfigManager.getConfig(
      'config.config.registration.desktop_popup',
    );

    if (enableSignUpDelay) setNextShowForPopupSignUpDelay();
  }, []);
};
